import { useEffect, useState } from "react";
export var useDebouncedValue = function (value, delayMs) {
    var _a = useState(value), debouncedValue = _a[0], setDebouncedValue = _a[1];
    useEffect(function () {
        var timer = setTimeout(function () { return setDebouncedValue(value); }, delayMs);
        return function () { return clearTimeout(timer); };
    }, [value, delayMs]);
    return debouncedValue;
};
